import { get } from "lodash";
export var transformPermittedUsers = function transformPermittedUsers(data) {
  var results = get(data, ["results"], []);
  if (!Array.isArray(results)) return [];
  return results.map(function (user) {
    return transformUser(user);
  }).filter(function (user) {
    return isValidUser(user);
  });
};
var transformUser = function transformUser(user) {
  return {
    id: get(user, "id", -1),
    name: get(user, "name", ""),
    email: get(user, "email", ""),
    role: get(user, "role", "")
  };
};
var isValidUser = function isValidUser(user) {
  return user.id !== -1 && !!user.name && !!user.email && !!user.role;
};